import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Grid, Button, Container } from '@mui/material';
import { FileInput } from './FileInput';
import ReactPlayer from 'react-player';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import { formatTime, roundTo } from '../helpers';

// const cameraAngles = ['front', 'rear', 'combined', 'other'];
//https://youtu.be/GG2M4MeSO0s

export default function VideoSelection({
  liftVideoFileDetails,
  videoFileDetails,
  liftVideoMarkers,
  videoMarkers,
  setVideoYoutubeUrl,
  videoYoutubeUrl,
}) {
  const ref = React.useRef(null);
  const [vidTime, setVidTime] = React.useState(0);
  const [vidUrl, setVidUrl] = React.useState(null);
  const [isYoutube, setIsYoutube] = React.useState(false);

  React.useEffect(() => {
    // decide to use youtube url or file
    if (videoYoutubeUrl) {
      setVidUrl(videoYoutubeUrl);
    } else if (videoFileDetails?.fileurl) {
      setVidUrl(videoFileDetails?.fileurl);
    } else {
      setVidUrl(null);
    }
  }, [videoFileDetails?.fileurl, videoYoutubeUrl]);

  const updateCurrentTime = (event) => {
    setVidTime(event);
    // setVidTime(event.target.currentTime);
  };

  const liftCrossStartLine = () => {
    liftVideoMarkers((l) => ({ ...l, startLineTime: vidTime }));
  };

  async function getVidDuration(event) {
    liftVideoMarkers((l) => ({ ...l, vidDuration: event }));
    // liftVideoMarkers((l) => ({ ...l, vidDuration: event.target.duration }));
  }
  function handleVideoUrl(e) {
    e.preventDefault();
    const form = new FormData(e.currentTarget);
    const body = {};
    for (const [key, value] of form.entries()) {
      body[key] = value;
    }
    const xs = body['video-url'];
    setVideoYoutubeUrl(xs);
  }

  return (
    <React.Fragment>
      <Container>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            columnGap: '20px',
            paddingBottom: '20px',
          }}
        >
          <Button
            onClick={() => setIsYoutube(false)}
            variant={isYoutube ? '' : 'outlined'}
            size="large"
          >
            File Upload
          </Button>
          <Button
            onClick={() => setIsYoutube(true)}
            variant={!isYoutube ? '' : 'outlined'}
            size="large"
          >
            Link to Youtube
          </Button>
        </Box>

        {isYoutube && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              paddingBottom: '20px',
            }}
          >
            <form onSubmit={handleVideoUrl}>
              <TextField
                label="Youtube URL"
                id="video-url"
                name="video-url"
                size="small"
              />
              <Button
                type="submit"
                variant="outlined"
                sx={{ marginLeft: '10px' }}
              >
                Submit
              </Button>
            </form>
          </Box>
        )}
        {!isYoutube && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              paddingBottom: '20px',
            }}
          >
            <Typography component="div" variant="h6" gutterBottom>
              Choose the video file to upload.
            </Typography>
            <Box>
              <FileInput
                file={videoFileDetails?.file}
                handleChange={liftVideoFileDetails}
              />
            </Box>
          </Box>
        )}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
              <ReactPlayer
                style={{ position: 'absolute', top: 0, left: 0 }}
                url={vidUrl}
                progressInterval={100}
                onProgress={(progress) => {
                  updateCurrentTime(progress.playedSeconds);
                }}
                onBuffer={() => console.log('buffering')}
                ref={ref}
                // playing={isPlaying}
                onReady={() => console.log('ready')}
                onError={(error) => console.log(error)}
                onDuration={(d) => getVidDuration(d)}
                // onPlay={handlePlay}
                // onPause={handlePause}
                // onEnded={handleEnded}
                controls={true}
                // playsInline
                width="100%"
                height="100%"
              />
            </Box>
          </Grid>
        </Grid>
        {(videoFileDetails || videoYoutubeUrl) && (
          <Grid container spacing={3}>
            <Grid item xs={12} marginBottom={2}>
              <div>
                Cue the video to when you cross the startline for the first
                RaceHero lap (Lap 1)
              </div>
              <div>Elapsed Video Time: {formatTime(roundTo(vidTime, 3))}</div>
              <div>
                {' '}
                Marked Cross Start Time:
                {formatTime(roundTo(videoMarkers.startLineTime, 3))}
              </div>
              <Button onClick={liftCrossStartLine} variant="outlined">
                Mark Cross Start
              </Button>
            </Grid>
          </Grid>
        )}
      </Container>
    </React.Fragment>
  );
}
